/**
 * Edge types for sweep line algorithm
 */
export enum EdgeType {
  NORMAL = 0,
  NON_CONTRIBUTING = 1,
  SAME_TRANSITION = 2,
  DIFFERENT_TRANSITION = 3,
}